import { Link } from "@teamprevent/common/task/taskActions/models";
import { User } from "reauthorize";

export interface CurrentUser extends User {
    id?: string;
    name: string;
    email?: string;
    mobilePhone?: string;
    customers: Link[];
    currentCustomer?: Link;
    termsAcceptanceRequired: boolean;
    canSwitchBetweenPortals: boolean;
    ohDirect: boolean;
}

export interface CurrentUserState extends CurrentUser {
    mismatchedCustomer?: true;
}

export interface Role {
    displayName: string;
    name: string;
}

export const CUSTOMER_ROLES = {
    manager: { displayName: "Manager", name: "Manager" },
    hr: { displayName: "HR", name: "Hr" },
    recruitmentManager: { displayName: "Recruitment Manager", name: "RecruitmentManager" },
    customerAdministrator: { displayName: "Administrator", name: "CustomerAdministrator" },
    caseManager: { displayName: "Case Manager", name: "CaseManager" },
    sraManager: { displayName: "SRA Manager", name: "SraManager" },
    sraDepartmentLead: { displayName: "SRA Department Lead", name: "SraDepartmentLead" },
    otherServices: { displayName: "Other Services", name: "OtherServices" }
};

export const isCustomerAdministrator = (user: { roles: string[] }) => user.roles.includes(CUSTOMER_ROLES.customerAdministrator.name);

export const isCaseManager = (user: { roles: string[] }) => user.roles.includes(CUSTOMER_ROLES.caseManager.name);

export const notCaseManagerRole = (role: string) => role !== "caseManager";

export const notAdministratorRole = (role: string) => role !== "customerAdministrator";

export const notAnySraRole = (role: string) => role !== "sraManager" && role !== "sraDepartmentLead";

export const anySraRole = (user: { roles: string[] }) =>
    user.roles.some(r => r === CUSTOMER_ROLES.sraManager.name || r === CUSTOMER_ROLES.sraDepartmentLead.name);

export const canRequestOtherServices = (user: { roles: string[] }) => user.roles.includes(CUSTOMER_ROLES.otherServices.name);
